<template>
    <div>
        <label class="circle-checkbox">
            <img v-if="isChecked" class="radio-img"  src="@/assets/img/component/widge/circle_radio/radio_green.svg" alt="">
            <img v-else class="radio-img"  src="@/assets/img/component/widge/circle_radio/radio_gray.svg" alt="">
            <input type="radio" :value="val" v-model="checked" @change="onChange" />
            {{checkboxMsg}}
        </label>
    </div>
</template>
<script>
export default {
    name: 'rentCheckbox',
    data () {
        return {
            // isChecked: true,
            isChecked: this.isPropChecked,
            checkVal: '',
            checkedImg: require('@/assets/img/component/widge/circle_radio/radio_gray.svg'),
        }
    },
    props: {
        checkboxMsg: String,
        val: '',
        value: '',
        isPropChecked: {
            default: true,
            type: Boolean
        },
        setDefault: Boolean
    },
    watch: {
        isPropChecked: function (val) {
            this.isChecked = val
        },
        setDefault: function () {

        }
    },
    computed: {
        checked: {
            get () {
                return this.value
            },
            set (val) {
                this.checkVal = val
            }
        }
    },
    methods: {
        onChange: function(e) {
            this.isChecked = true;
            this.$emit('input', this.checkVal)
        }
    }
}
</script>
<style   lang="scss">
    .circle-checkbox{
        position: relative;
        display: flex;
        align-items: center;
        font-size: 14px;
        cursor: pointer;
        color: #525956;
        font-weight: 300;
        .radio-img{
            margin-right: 8px;
        }
        input{
            display: none;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/widge/CircleRadio.vue